import ImportIcon from "components/Icons/ImportIcon";
import FileIcon from "components/Icons/FileIcon";
import GroupsIcon from "components/Icons/GroupsIcon";
import CalendarIcon from "components/Icons/CalendarIcon";
import type { UpsellPageContent } from "../Upsell.types";
import UpsellPageLayout from "../components/UpsellPageLayout";
import videos from "config/videos";

/** Static, so it lives at module scope rather than behind an empty-dep `useMemo`. */
const CONTENT: UpsellPageContent = {
  feature: "OutputProgram",
  eyebrow: "upsell.output_program_nav_label",
  heading: "upsell.output_program_heading",
  subheading: "upsell.output_program_subheading",
  bannerPrompt: "upsell.output_program_banner_prompt",
  ctaHeading: "upsell.output_program_cta_heading",
  ctaDescription: "upsell.request_access_cta_description",
  video: videos.calendarsAndPrograms,
  cards: [
    {
      icon: ImportIcon,
      title: "upsell.output_program_card_import_title",
      description: "upsell.output_program_card_import_description",
    },
    {
      icon: FileIcon,
      title: "upsell.output_program_card_templates_title",
      description: "upsell.output_program_card_templates_description",
    },
    {
      icon: GroupsIcon,
      title: "upsell.output_program_card_bulk_title",
      description: "upsell.output_program_card_bulk_description",
    },
    {
      icon: CalendarIcon,
      title: "upsell.output_program_card_delivery_title",
      description: "upsell.output_program_card_delivery_description",
    },
  ],
};

function UpsellOutputProgram() {
  return <UpsellPageLayout content={CONTENT} />;
}

export default UpsellOutputProgram;
